import { defineMessages } from 'react-intl';

export default defineMessages({
  
  searchbar_filter: {
    id: 'admin.searchbar.filter',
    defaultMessage: 'Filter'
  },

  title_actions: {
    id: 'admin.title.actions',
    defaultMessage: 'Actions'
  },
  title_confirm: {
    id: 'admin.title.confirm',
    defaultMessage: 'Confirm'
  },
  title_yes: {
    id: 'admin.title.yes',
    defaultMessage: 'Yes'
  },
  title_no: {
    id: 'admin.title.no',
    defaultMessage: 'No'
  },
  title_default: {
    id: 'admin.title.default',
    defaultMessage: 'Default'
  },

  sectionform_title_expand_all: {
    id: 'admin.title.expand_all',
    defaultMessage: 'Expand all'
  },
  sectionform_title_collapse_all: {
    id: 'admin.title.collapse_all',
    defaultMessage: 'Collapse all'
  },

  btn_title_default_add: {
    id: 'admin.btn.default.add',
    defaultMessage: 'Add'
  },
  btn_title_default_update: {
    id: 'admin.btn.default.update',
    defaultMessage: 'Update'
  },
  btn_title_default_add_or_update: {
    id: 'admin.btn.default.add_or_update',
    defaultMessage: 'Add or Update'
  },
  btn_title_default_save: {
    id: 'admin.btn.default.save',
    defaultMessage: 'Save'
  },
  btn_title_default_saveas: {
    id: 'admin.btn.default.saveas',
    defaultMessage: 'Save As'
  },
  btn_title_default_cancel: {
    id: 'admin.btn.default.cancel',
    defaultMessage: 'Cancel'
  },
  btn_title_default_reset: {
    id: 'admin.btn.default.reset',
    defaultMessage: 'Reset'
  },
  btn_title_default_delete: {
    id: 'admin.btn.default.delete',
    defaultMessage: 'Delete'
  },
  btn_title_default_refresh: {
    id: 'admin.btn.default.refresh',
    defaultMessage: 'Refresh'
  },
  btn_title_default_edit: {
    id: 'admin.btn.default.edit',
    defaultMessage: 'Edit'
  },

  msg_confirm_delete_record: {
    id: 'admin.msg.confirm.delete.record',
    defaultMessage: 'Are you sure you want to delete this record?'
  },
  msg_confirm_unsaved_changes: {
    id: 'admin.msg.confirm.unsaved.changes',
    defaultMessage: 'There are unsaved changes. Are you sure you want to leave this page?'
  },

  dropdown_default_msg : {
    id: 'admin.dropdown.default.msg',
    defaultMessage: 'Select one'
  },
  
  paginator_rows_per_page: {
    id: 'admin.paginator.rowsperpage',
    defaultMessage: 'Rows per page'
  },
  paginator_msg_of: {
    id: 'admin.paginator.msg_of',
    defaultMessage: 'of'
  },


  sagas_saveAs : {
    id: 'admin.sagas.saveAs',
    defaultMessage: 'This is a copy. Please click "Save" when done.'
  },

  title_prompt: {
    id: 'admin.common.prompt.info',
    defaultMessage: 'Information',
  },
});
